import axios from "axios";
import qs from "qs";
import {USER} from "../constant";

export const BE_BASE_URL = "https://gongzi.hn-xiangyi.cn/api/salary_management";
// export const BE_BASE_URL = "http://localhost:8081"

export const FE_BASE_URL = "https://gongzi.hn-xiangyi.cn"
// export const FE_BASE_URL = "http://localhost:3000"

function generateUrl(url) {
  return BE_BASE_URL + url;
}

const Url = {
  fetchCaptcha: generateUrl("/captcha"),
  isNeedCaptcha: generateUrl("/captcha/need"),
  userLogin: generateUrl("/user/login"),
  userLoginByWx: "http://bill.cab:8080/wxbe/qyweixin/entry",
  checkUserLoginByWx: generateUrl("/user/checkLoginByWx"),
  userLogout: generateUrl("/user/logout"),
  userUpdate: generateUrl("/user/update"),
  adminLogin: generateUrl("/admin/login"),
  adminLogout: generateUrl("/admin/logout"),
  adminUpdate: generateUrl("/admin/update"),
  fetchUserManageList: generateUrl("/admin/getAllUser"),
  checkSalaryList: generateUrl("/salary/check"),
  deleteUser: generateUrl("/admin/deleteUser"),
  restoreUser: generateUrl("/admin/restoreUser"),
  addUserAccount: generateUrl("/admin/registerUser"),
  updateUserInfo: generateUrl("/admin/updateUserInfo"),
  uploadSalaryList: generateUrl("/salary/add"),
  fetchSalaryList: generateUrl("/salary/get"),
  deleteSalary: generateUrl("/salary/delete"),
  getBackupFile: generateUrl("/admin/getBackupFile"),
}

const Query = {
  login: (data, userType) => {
    return axios({
      url: userType === USER ? Url.userLogin : Url.adminLogin,
      method: 'post',
      data: qs.stringify(data),
    })
  },
  loginByWx: () => {
    return axios({
      url: Url.userLoginByWx,
      method: 'get',
    })
  },
  checkLoginByWx: (data) => {
    return axios({
      url: Url.checkUserLoginByWx,
      method: 'post',
      data: qs.stringify(data),
    })
  },
  logout: (userType) => {
    return axios({
      url: userType === USER ? Url.userLogout : Url.adminLogout,
      method: 'put',
    })
  },
  askNeedCaptcha: (data) => {
    return axios({
      url: Url.isNeedCaptcha,
      method: 'get',
      params: data
    })
  },
  fetchCaptcha: (data) => {
    return axios({
      url: Url.fetchCaptcha,
      method: 'post',
      data: qs.stringify(data),
    })
  },
  fetchSalary: (data) => {
    return axios({
      url: Url.fetchSalaryList,
      method: 'get',
      params: data
    })
  },
  uploadSalary: (data) => {
    return axios({
      url: Url.uploadSalaryList,
      method: 'post',
      headers: {
        'Content-Type': 'application/json;'
      },
      data,
    })
  },
  checkSalary: (data) => {
    return axios({
      url: Url.checkSalaryList,
      method: 'post',
      headers: {
        'Content-Type': 'application/json;'
      },
      data,
    })
  },
  deleteSalary: (data) => {
    return axios({
      url: Url.deleteSalary,
      method: 'delete',
      headers: {
        'Content-Type': 'application/json;'
      },
      data
    })
  },
  updatePassword: (data, userType) => {
    return axios({
      url: userType === USER ? Url.userUpdate : Url.adminUpdate,
      method: 'put',
      data: qs.stringify(data)
    })
  },
  addUserAccount: (data) => {
    return axios({
      url: Url.addUserAccount,
      method: 'post',
      data: qs.stringify(data),
    })
  },
  deleteUserAccount: (username) => {
    return axios({
      url: Url.deleteUser + "/" + username,
      method: 'delete',
    })
  },
  updateUserAccountInfo: (data) => {
    return axios({
      url: Url.updateUserInfo,
      method: 'put',
      data: qs.stringify(data),
    })
  },
  restoreUserAccount: (username) => {
    return axios({
      url: Url.restoreUser + "/" + username,
      method: 'post',
    })
  },
  fetchUserManageList: () => {
    return axios({
      url: Url.fetchUserManageList,
      method: 'get',
    })
  },
  getBackupFile: () => {
    return axios({
      url: Url.getBackupFile,
      method: 'get',
    })
  }
}
export default Query;